export let nav = {
	lenis: null,
	active: function( lenis ){
		if( lenis ){
			nav.lenis = lenis;
		}
		let $btnScrolls	= document.querySelectorAll("a[data-scroll]");
		
		if( $btnScrolls ){
			//multiple handlers
			const eventListenersMultiple = [
				{ elements: $btnScrolls, type: "click", handler: nav.scrollTo }
			];
			eventListenersMultiple.forEach( ( el ) => {
				el.elements.forEach( ( element )=> {
					element.removeEventListener(el.type, el.handler, false);
					element.addEventListener(el.type, el.handler, false);
				});
			});
		}
	},
	scrollTo: function(e){
		e.preventDefault();
		let $html 	= document.documentElement;
		let $this 	= this;
		let id 		= this.getAttribute("href");
		let $dom 	= document.querySelector(id);
		let posY 	= Math.floor( $dom.getBoundingClientRect().top + window.pageYOffset);
		let isMobile = window.matchMedia('(max-width: 864px)').matches;
		
		scrollToElementWithEasing(posY, 600);
		function scrollToElementWithEasing(targetY, duration = 800, callback = () => {}) {
			const startY = window.scrollY;
			const diff = targetY - startY;
			const startTime = performance.now();
			
			function step(currentTime) {
				const time = Math.min(1, (currentTime - startTime) / duration);
				const eased = easeInOutQuad(time);
				window.scrollTo(0, startY + diff * eased);
			
				if (time < 1) {
					requestAnimationFrame(step);
				} else {
					callback();
				}
			}
			 requestAnimationFrame(step);
		}
		function backairsteppy($as){
			$this.classList.remove("jump");
		}
	}
}
function easeInOutQuad(t) {
	return t < 0.5
	? 2 * t * t
	: -1 + (4 - 2 * t) * t;
}